import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-delete-link-job',
  templateUrl: './delete-link-job.component.html',
  styleUrls: ['./delete-link-job.component.scss']
})
export class DeleteLinkJobComponent implements OnInit {

  token = localStorage.getItem('token');
  // allLinkData:any;
allLinkData:any;
  constructor(
    private dialogRef: MatDialogRef<DeleteLinkJobComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _serverService:ServerService,
    private clipBoardMessageService:messageService,
  ) { }

  ngOnInit() {
    // console.log(this.data)
    this.allLinkData = this.data
  }
  close() {
    this.dialogRef.close();
  }
  deleteLinkComponent(){
    // let temp = this.allLinkData.all_links.filter((item)=>{
    //   return item.id != this.allLinkData.delete_link_id
    //   return 
    // });
    let filteredArr = this.allLinkData.all_links.filter((_, index) => index !== this.allLinkData.link_id);
    // console.log(filteredArr);
    let body = {
      // "open_file_link": filteredArr,
      "campaign_id":this.allLinkData.extra_parameter
    }
    let url;
    if(this.data.job_name == 'creative'){
      body['open_file_link'] = filteredArr
      url = 'campaign_module/creative_jobs/'
    }
    if(this.data.job_name == 'escalation'){
      body['supporting_links'] = filteredArr;
       url = 'campaign_module/escalation/'
    }
    
// return;
    this._serverService.editCreativeJob(url+this.allLinkData.job_id,body,this.token).subscribe((data)=>{
      // console.log(data)
      localStorage.setItem('link_deletion_job','true')
      this.clipBoardMessageService.showMessgeInText("Link Updated Succesfully", "success-snackbar")
      this.dialogRef.close(filteredArr);
    },
    error => {
     console.error('Deletion of Link failed', error);
    //  this.btnStatus = false;
     // this.showComponentLoader = false;
   })
  }
}
